import { render, staticRenderFns } from "./CategoriesBody.vue?vue&type=template&id=de906c26"
import script from "./CategoriesBody.vue?vue&type=script&lang=ts"
export * from "./CategoriesBody.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesBody.vue?vue&type=style&index=0&id=de906c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports